import { render } from "./HomeParentingView.vue?vue&type=template&id=6d0cf784"
import script from "./HomeParentingView.vue?vue&type=script&lang=js"
export * from "./HomeParentingView.vue?vue&type=script&lang=js"

import "./HomeParentingView.vue?vue&type=style&index=0&id=6d0cf784&lang=css"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__